import { css } from 'styled-components';
import { mediaTemplates } from 'theme/variables';

const mediaQueries = css`
  ${mediaTemplates.xs} {
    height: calc(((100vw - 66px) / 2) / 16 * 9);
  }
  ${mediaTemplates.mWidth} {
    height: calc(((100vw - 66px) / 4) / 16 * 9);
  }
  ${mediaTemplates.lWidth} {
    height: calc(((940px - 66px) / 5) / 16 * 9);
  }
`;

export default mediaQueries;
